import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { NUM_RESULTS_PER_PAGE } from '@app/shared/search.token';

@Component({
  selector: 'dgx-search-results-pagination',
  templateUrl: './search-results-pagination.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultsPaginationComponent {
  @Output() public pageChange = new EventEmitter<number>();

  @Input() public totalContentResults: number;
  @Input() public pageNum: number = 1;

  constructor(
    @Inject(NUM_RESULTS_PER_PAGE) public readonly numResultsPerPage: number
  ) {}

  public get showPagination(): boolean {
    return this.totalContentResults > this.numResultsPerPage;
  }
}
